const swapMobileImages = () => {
  if (window.innerWidth > 991) {
    return;
  }
  const list = document.querySelectorAll("div[data-mobile-image]");
  for (let i = 0; i < list.length; i += 1) {
    const url = list[i].getAttribute('data-mobile-image');
    if (url) {
      list[i].style.backgroundImage=`url(${url})`;
    }
  }
}

export default swapMobileImages;
